import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidElement } from "react";
import { StyleSheet, View } from "react-native";
import NativeMask from "../specs/OneNativeMaskNativeComponent";
var warnedInvalidMask = false;
function Mask(props) {
  var { maskElement, style, children, ...viewProps } = props;
  if (!/* @__PURE__ */ isValidElement(maskElement)) {
    if (!warnedInvalidMask) {
      warnedInvalidMask = true;
      console.warn("Mask: invalid `maskElement` prop was passed to Mask. expected a React element. no mask will render.");
    }
    return /* @__PURE__ */ _jsx(View, {
      style,
      ...viewProps,
      children
    });
  }
  return /* @__PURE__ */ _jsxs(NativeMask, {
    style,
    ...viewProps,
    children: [
      /* @__PURE__ */ _jsx(View, {
        pointerEvents: "none",
        style: StyleSheet.absoluteFill,
        children: maskElement
      }),
      children
    ]
  });
}
export {
  Mask
};
//# sourceMappingURL=Mask.native.js.map
